import { Injectable } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

	constructor() { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const token = localStorage.getItem('auth_token');

		// Don't add Authorization header for auth endpoints
		if (request.url.includes('/auth')) {
			return next.handle(request);
		}

		if (token) {
			const cloned = request.clone({
				setHeaders: {
					Authorization: `Bearer ${token}`
				}
			});
			return next.handle(cloned);
		}

		return next.handle(request);
	}
}